module.exports = "/static/images/jilden.png";